// extracted by mini-css-extract-plugin
export default {"size-default":"TuQhLyjzFlTnNvEl16cq","square-standard":"wxDQEowKApMMlL_CcAKH","size-larger":"QI1h105eTHlFW3oCt4E_","common_bganimation":"LjMl8wPSwEI5iSYteTqH"};